import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AbstractDynamicComponent } from '@components/abstracts';
import { ListingAutresFacades } from '@components/listing-autres-facades/models';
import { TranslatePipe } from '@ngx-translate/core';
import { OptionCardComponent } from '@shared/components/option-card';
import { SvgComponent } from '@shared/components/svg';
import { TitleComponent } from '@shared/components/title';
import { GenerateRangePipe } from '@shared/pipe';
import { ElasticSearchService } from '@shared/services/elastic-search';
import { OtherFront } from '@shared/services/elastic-search/models';
import { LogsService } from '@shared/services/logs';
import { take } from 'rxjs';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'app-listing-autres-facades',
  templateUrl: './listing-autres-facades.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TitleComponent, OptionCardComponent, RouterLink, GenerateRangePipe, SvgComponent, TranslatePipe],
})
export class ListingAutresFacadesComponent extends AbstractDynamicComponent<ListingAutresFacades> implements OnInit {
  protected otherFronts = signal<OtherFront[]>([]);
  private readonly elasticSearchService = inject(ElasticSearchService);
  private readonly logs = inject(LogsService);

  ngOnInit() {
    this.elasticSearchService
      .getOtherFronts(this.data.notCategory)
      .pipe(
        take(1),
        tap((otherFronts) => {
          this.otherFronts.set(otherFronts);
        })
      )
      .subscribe({ error: (err) => this.logs.error('ListingAutresFacadesComponent', 'getOtherFronts failed', err) });
  }
}
